/* global axios */
import ApiClient from './ApiClient';

class CeaLookupsAPI extends ApiClient {
  constructor() {
    super('cea_lookups', { accountScoped: true });
  }

  get(type) {
    return axios.get(this.url, { params: { type } });
  }

  create(type, data) {
    return axios.post(this.url, { type, cea_lookup: data });
  }

  show(type, id) {
    return axios.get(`${this.url}/${id}`, { params: { type } });
  }

  update(type, id, data, subcategoryIds = null) {
    const payload = { type, cea_lookup: data };
    if (subcategoryIds !== null) {
      payload.subcategory_ids = subcategoryIds;
    }
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(type, id) {
    return axios.delete(`${this.url}/${id}`, { params: { type } });
  }
}

export default new CeaLookupsAPI();
